import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(6),
    marginTop: theme.spacing(6),
  },

  options: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },

  icon: {
    display: 'flex',
    alignItems: 'center',
    width: 28,
  },
}));
